import React from 'react';
import moment from "moment";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faExternalLinkAlt} from "@fortawesome/free-solid-svg-icons";

import FormEttDropdownItems from "./FormEttDropdownItems";
import TimezoneSelector from "./TimezoneSelector";
import DateTimePicker from "./DateTimePicker";
import WidgetPreview from "./WidgetPreview";
import QuestionListGuessNumber from "./QuestionListGuessNumber";
import QuestionListFreeForm from "./QuestionListFreeForm";
import QuestionListMultipleChoice from "./QuestionListMultipleChoice";

import * as api from "../util/api";

import "./Form.css";

export default class Form extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const completeUrl = api.generateUrl(this.props.draftActiveProject);
    const qrUrl = completeUrl && api.toQrUrl(completeUrl);

    const linksContent = (
      <a
        className="form-link"
        href={completeUrl}
        target="_blank"
      >
        <div className="form-link-text">
          {completeUrl}
        </div>
        <FontAwesomeIcon
          className="form-link-icon"
          icon={faExternalLinkAlt}
        />
      </a>
    );

    const qrContent = (
      <div className="form-drawing-url-qr-container" style={{width:100,height:100}}>
        <a href={qrUrl} target="_blank">
          <img
            alt="QR code for this join"
            className="form-drawing-url-qr-img"
            src={qrUrl}
          />
          <div className="form-drawing-url-qr-text">
            Enlarge
          </div>
        </a>
      </div>
    );

    return (
      <form className="form">
        <div className="heading">Details</div>
        <div className="form-row">
          <div className="form-group col-12">
            <label className="form-label" htmlFor="js-form-title">Title</label>
            <input
              name="title"
              type="text"
              value={this.props.draftActiveProject.title}
              className="form-control form-input"
              placeholder="DevNet Join Day 1"
              id="js-form-title"
              onChange={this.props.handleInputChange()}
            >
            </input>
          </div>
        </div>

        <div className="form-row">
          <div className="form-group col-12">
            <label className="form-label" htmlFor="js-form-description">Description</label>
            <textarea
              name="description"
              value={this.props.draftActiveProject.description}
              className="form-control form-input-textarea"
              placeholder="Enter for your chance to win an awesome DevNet t-shirt!"
              id="js-form-description"
              rows="3"
              onChange={this.props.handleInputChange()}
            >
            </textarea>
          </div>
        </div>

        <div className="form-row">
          <div className="form-group col-12">
            <label className="form-label" htmlFor="js-form-ett-name">ETT Name</label>
            <select className="form-control form-input" id="js-form-ett-name"
              name="ett_id"
              value={this.props.draftActiveProject.ett_id || ""}
              onChange={this.props.handleEttChange}
            >
              <option value="">Not linked</option>
              <FormEttDropdownItems ettEventList={this.props.ettEventList} />
            </select>
          </div>
        </div>

        <div className="form-row">
          <div className="form-group col-12">
            <label className="form-label" htmlFor="js-form-secret">Secret URL path</label>
            <label className="form-label-oblique">If this option is set, the widget will only be visible if "#YOURPATH" is included at the end of the URL (case insensitive).</label>
            <input
              name="secret_url_path"
              type="text"
              placeholder="YOURPATH"
              value={this.props.draftActiveProject.secret_url_path}
              className="form-control form-input"
              id="js-form-secret"
              onChange={this.props.handleInputChange()}
            >
            </input>
          </div>
        </div>

        <div className="form-row">
          <div className="form-group col-12">
            <label className="form-label" htmlFor="js-form-drawing-url">Event URL</label>
            <label className="form-label-oblique">This is the URL/path the join will be tied to and where you will place the widget.</label>
            <input
              name="raffle_url"
              type="text"
              placeholder="/site/my-drawing-event/"
              value={this.props.draftActiveProject.raffle_url}
              className="form-control form-input"
              id="js-form-drawing-url"
              onChange={this.props.handleInputChange()}
            >
            </input>
          </div>
        </div>

        <div className="form-row">
          <div className="form-group col-12">
            <div className="form-drawing-url-container">
              <div className="form-drawing-url-content-container">
                <label className="form-label d-flex align-items-center">Join URL
                  {
                    completeUrl && (
                      this.props.draftActiveProject.secret_url_path
                      ? <span className="form-label-note is-protected">protected</span>
                      : <span className="form-label-note is-public">public</span>
                    )
                  }
                </label>
                <label className="form-label-oblique">You can share/shorten this URL which is where the join will appear.</label>
                {completeUrl && linksContent}
              </div>
              {completeUrl && qrContent}
            </div>
          </div>
        </div>

        <div className="form-row">
          <div className="col-12">
            <label className="form-label" htmlFor="js-form-rules">Join and promotion rules</label>
            <label className="form-label-oblique">If you need to change the “Official Promotion Rules” for your join you can update that here. It allows for an external URL which will appear as a link on the widget.</label>
          </div>
        </div>

        <div className="form-row">
          <div className="form-group col-12">
            <input
              name="promotion_rule"
              type="url"
              value={this.props.draftActiveProject.promotion_rule}
              className="form-control form-input"
              placeholder="https://developer.cisco.com/site/drawing-promo-rules"
              id="js-form-rules"
              onChange={this.props.handleInputChange()}
            >
            </input>
          </div>
        </div>

        <div className="heading">How long will this join run for?</div>

        <div className="form-row">
          <div className="col-12">
            <label className="form-label-oblique">This is really critical as the join widget will only appear at your Start Time and will stop displaying at your End Time.</label>
          </div>
        </div>

        <div className="form-row">
          <div className="form-group col-12">
            <label className="form-label" htmlFor="js-form-tz">Timezone</label>

            <TimezoneSelector
              timezone={this.props.draftActiveProject.timezone}
              handleInputChange={this.props.handleInputChange}
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group col-12">
            <label className="form-label">Start Time</label>
            <DateTimePicker
              name="start"
              value={this.props.draftActiveProject.start}
              handleDateTimeChange={this.props.handleDateTimeChange}
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group col-12">
            <label className="form-label-light">
              UTC: {moment.utc(`${this.props.draftActiveProject.start}${this.props.draftActiveProject.timezone.split('#')[0]}`).format("LLL")}
            </label>
          </div>
        </div>

        <div className="form-row">
          <div className="form-group col-12">
            <label className="form-label">End Time</label>
            <DateTimePicker
              name="end"
              value={this.props.draftActiveProject.end}
              handleDateTimeChange={this.props.handleDateTimeChange}
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group col-12">
            <label className="form-label-light">
              UTC: {moment.utc(`${this.props.draftActiveProject.end}${this.props.draftActiveProject.timezone.split('#')[0]}`).format("LLL")}
            </label>
          </div>
        </div>

        { // TODO: Re-implement when included in back-end.
        /*<div className="form-row">
          <div className="form-group col-12">
            <label className="form-label" htmlFor="js-form-auto-draw">Do you want a winner to automatically be picked on the end date of the join?</label>

            <label className="switch">
              <input
                name="auto_draw"
                id="js-form-auto-draw"
                type="checkbox"
                checked={this.props.draftActiveProject.auto_draw}
                onChange={this.props.handleInputChange()}
              >
              </input>
              <span className="slider"></span>
            </label>
          </div>
        </div>*/}

        <div className="form-row">
          <div className="form-group col-12">
            <label className="form-label" htmlFor="js-form-widget-visibility">Should the widget for this drawing be visible?</label>

            <label className="switch">
              <input
                name="widget_visibility"
                id="js-form-widget-visibility"
                type="checkbox"
                checked={this.props.draftActiveProject.widget_visibility}
                onChange={this.props.handleInputChange()}
              >
              </input>
              <span className="slider"></span>
            </label>
          </div>
        </div>

        <div className="form-row">
          <div className="form-group col-12">
            <label className="form-label" htmlFor="js-form-show-profile-photo">Should profile avatars be shown on the Winners page for this drawing?</label>

            <label className="switch">
              <input
                name="show_profile_photo"
                id="js-form-show-profile-photo"
                type="checkbox"
                checked={this.props.draftActiveProject.show_profile_photo}
                onChange={this.props.handleInputChange()}
              >
              </input>
              <span className="slider"></span>
            </label>
          </div>
        </div>

        <div className="heading">Joining questions</div>

        <div className="form-row">
          <div className="col-12">
            <label className="form-label-oblique">The join widget offers 3 options for questions: multiple choice to get feedback or gauge interest, guess the amount which you allows you to have have an amount (person who is closest wins), and no question which allows for people to just easily enter with no barrier.</label>
          </div>
        </div>

        <div className="form-row">
          <div className="col-12">
            <label className="form-label">Question 1</label>
          </div>
        </div>

        <div className="form-row">
          <div className="col-6">
            <div className="form-group form-check-inline">
              <input
                name="type-q1"
                type="radio"
                className="form-check-input"
                id="js-form-radio-none"
                value="none"
                checked={this.props.draftActiveProject.questions[0].type === "none"}
                onChange={this.props.handleQuestionTypeChange(0)}
              >
              </input>
              <label className="form-check-label form-label-light" htmlFor="js-form-radio-none">No question</label>
            </div>
          </div>

          <div className="col-6">
            <div className="form-group form-check-inline">
              <input
                name="type-q1"
                type="radio"
                className="form-check-input"
                id="js-form-radio-guess-number"
                value="guess_number"
                checked={this.props.draftActiveProject.questions[0].type === "guess_number"}
                onChange={this.props.handleQuestionTypeChange(0)}
              >
              </input>
              <label className="form-check-label form-label-light" htmlFor="js-form-radio-guess-number">Guess a number</label>
            </div>
          </div>
        </div>

        <div className="form-row">
          <div className="col-6">
            <div className="form-group form-check-inline">
              <input
                name="type-q1"
                type="radio"
                className="form-check-input"
                id="js-form-radio-free-form"
                value="free_form"
                checked={this.props.draftActiveProject.questions[0].type === "free_form"}
                onChange={this.props.handleQuestionTypeChange(0)}
              >
              </input>
              <label className="form-check-label form-label-light" htmlFor="js-form-radio-free-form">Free form</label>
            </div>
          </div>

          <div className="col-6">
            <div className="form-group form-check-inline">
              <input
                name="type-q1"
                type="radio"
                className="form-check-input"
                id="js-form-radio-multiple-choice"
                value="multiple_choice"
                checked={this.props.draftActiveProject.questions[0].type === "multiple_choice"}
                onChange={this.props.handleQuestionTypeChange(0)}
              >
              </input>
              <label className="form-check-label form-label-light" htmlFor="js-form-radio-multiple-choice">Multiple choice</label>
            </div>
          </div>
        </div>

        <div className="form-question-selector">
          <QuestionListGuessNumber
            clsHidden={this.props.draftActiveProject.questions[0].type === "guess_number" ? "" : "is-hidden"}
            draftActiveProject={this.props.draftActiveProject}
            questionIndex={0}
            handleQuestionInputChange={this.props.handleQuestionInputChange}
            handleQuestionExpectedAnswersChange={this.props.handleQuestionExpectedAnswersChange}
          />

          <QuestionListFreeForm
            clsHidden={this.props.draftActiveProject.questions[0].type === "free_form" ? "" : "is-hidden"}
            draftActiveProject={this.props.draftActiveProject}
            questionIndex={0}
            handleQuestionInputChange={this.props.handleQuestionInputChange}
          />

          <QuestionListMultipleChoice
            clsHidden={this.props.draftActiveProject.questions[0].type === "multiple_choice" ? "" : "is-hidden"}
            draftActiveProject={this.props.draftActiveProject}
            questionIndex={0}
            handleQuestionInputChange={this.props.handleQuestionInputChange}
            handleQuestionOptionsChange={this.props.handleQuestionOptionsChange}
          />
        </div>

        <div className="form-row">
          <div className="col-12">
            <hr />

            <label className="form-label">Question 2</label>
          </div>
        </div>

        <div className="form-row">
          <div className="col-6">
            <div className="form-group form-check-inline">
              <input
                name="type-q2"
                type="radio"
                className="form-check-input"
                id="js-form-radio-none-q2"
                value="none"
                checked={this.props.draftActiveProject.questions[1].type === "none"}
                onChange={this.props.handleQuestionTypeChange(1)}
              >
              </input>
              <label className="form-check-label form-label-light" htmlFor="js-form-radio-none-q2">No question</label>
            </div>
          </div>
        </div>

        <div className="form-row">
          <div className="col-6">
            <div className="form-group form-check-inline">
              <input
                name="type-q2"
                type="radio"
                className="form-check-input"
                id="js-form-radio-free-form-q2"
                value="free_form"
                checked={this.props.draftActiveProject.questions[1].type === "free_form"}
                onChange={this.props.handleQuestionTypeChange(1)}
              >
              </input>
              <label className="form-check-label form-label-light" htmlFor="js-form-radio-free-form-q2">Free form</label>
            </div>
          </div>

          <div className="col-6">
            <div className="form-group form-check-inline">
              <input
                name="type-q2"
                type="radio"
                className="form-check-input"
                id="js-form-radio-multiple-choice-q2"
                value="multiple_choice"
                checked={this.props.draftActiveProject.questions[1].type === "multiple_choice"}
                onChange={this.props.handleQuestionTypeChange(1)}
              >
              </input>
              <label className="form-check-label form-label-light" htmlFor="js-form-radio-multiple-choice-q2">Multiple choice</label>
            </div>
          </div>
        </div>

        <div className="form-question-selector">
          <QuestionListFreeForm
            clsHidden={this.props.draftActiveProject.questions[1].type === "free_form" ? "" : "is-hidden"}
            draftActiveProject={this.props.draftActiveProject}
            questionIndex={1}
            handleQuestionInputChange={this.props.handleQuestionInputChange}
          />

          <QuestionListMultipleChoice
            clsHidden={this.props.draftActiveProject.questions[1].type === "multiple_choice" ? "" : "is-hidden"}
            draftActiveProject={this.props.draftActiveProject}
            questionIndex={1}
            handleQuestionInputChange={this.props.handleQuestionInputChange}
            handleQuestionOptionsChange={this.props.handleQuestionOptionsChange}
          />
        </div>

        <div className="form-row">
          <div className="form-group col-12">
            <hr />

            <label className="form-label" htmlFor="js-form-profile-question">Profile Question</label>

            <select
              id="js-form-profile-question"
              className="form-control form-input"
              name="profile_question"
              value={this.props.draftActiveProject.profile_question}
              onChange={this.props.handleInputChange()}
            >
              <option value="">
                No
              </option>

              <option value="random">
                Random
              </option>

              <option value="firstName">
                First Name
              </option>

              <option value="lastName">
                Last Name
              </option>

              <option value="displayName">
                Display Name
              </option>

              <option value="beName">
                Company
              </option>

              <option value="title">
                Title
              </option>

              <option value="role">
                Role
              </option>

              <option value="relationship">
                Relationship to Cisco
              </option>

              <option value="country">
                Country
              </option>
            </select>
          </div>
        </div>

        <div className="heading">Preview</div>

        <div className="form-row">
          <div className="form-group col-12">
            <WidgetPreview
              questions={this.props.draftActiveProject.questions}
              profileQuestion={this.props.draftActiveProject.profile_question}
            />
          </div>
        </div>
      </form>
    );
  }
}
